<template>
  <div :class="component_classes">
    <div>Anno</div>
    <v-select2
      @input="selectYear($event)"
      :class="select_classes"
      :name="'year'"
      :data-allow-clear="false"
      :required="year_required"
      :value="thisYear"
      :options-list="year"
    />
    <div>Mese</div>
    <v-select2
      @input="selectMonth($event)"
      :class="select_classes"
      :name="'month'"
      :required="month_required"
      :data-allow-clear="false"
      :options-list="month"
      :value="thisMonth"
    />
  </div>
</template>

<script>
import vSelect2 from '../../vSelect2';
import { Route } from '../../../route';
import { getCookie } from '../../../plugins/userUtils';

export default {
  name: 'monthYearFilter',
  props: ['buId', 'index', 'params', 'component_classes', 'select_classes', 'month_required', 'year_required'],
  components: {
    vSelect2,
  },
  mounted() {
    this.selectYear(this.thisYear);
    this.selectMonth(this.thisMonth);
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    thisMonth() {
      return moment().format('M');
    },
    thisYear() {
      return moment().format('YYYY');
    },
    month() {
      moment.locale('it');
      return moment.months().map((m, index) => [this.capitalize(m), index + 1]);
    },
    year() {
      const currentYear = new Date().getFullYear();
      const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
      return range(currentYear, currentYear - 10, -1).map((y) => [y, y]);
    },
  },
  methods: {
    capitalize(string) {
      if (typeof string !== 'string') return '';
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    selectYear(year) {
      this.$emit('selected', { data_selected: { year: year }, index: this.index });
    },
    selectMonth(month) {
      this.$emit('selected', { data_selected: { month: month }, index: this.index });
    },
  },
};
</script>

<style lang="scss" scoped>
.ml {
  margin-left: 36px;
}
</style>
